import { EMPTY_VALUE } from '@/constants';

const GENDER_LABELS: Record<string, string> = {
    masculino: 'Masculino',
    feminino: 'Feminino',
    outro: 'Outro',
};

export const translateGender = (gender?: string): string => {
    if (!gender) return EMPTY_VALUE;
    return GENDER_LABELS[gender.toLowerCase()] || gender;
};
